export enum ValidationOutcome {
  Unknown = 0,

  /// The provided input was valid.
  Valid = 1,
  
  /// The provided input was invalid, but no reason is specified.
  UnspecifiedFailure = 2,
  
  /// The provided input is required and was not supplied.
  NotSupplied = 3,
  
  /// The provided input was invalid because it has the wrong format.
  InvalidFormat = 4,
  
  /// The provided input was invalid because it was not in the specified range of valid values.
  InvalidValue = 5,
  
  /// The provided input was invalid because of a uniqueness constraint.
  AlreadyExists = 6,
  
  /// The provided input was invalid because the specified value is not allowed e.g. the specific value may have been blocked or otherwise disallowed for business reasons.
  NotAllowed = 7,
  
  /// The length of provided input was too big 
  TooLong = 8,
  
  /// The length of provided input was too short 
  TooShort = 9
}
